import classNames from 'classnames'
import { ResolvedCustomerType } from 'shared-types'
import RichText from '~/components/RichText/RichText'
import { usePage } from '~/hooks'
import styles from './MemberPricingBanner.module.scss'
import { MemberPricingBannerProps } from './MemberPricingBanner.types'

/**
 * A full-width strip the BFF adds above the breadcrumbs of a product listing page. It shows
 * guests the membership call to action and signed-in Standard customers the membership upgrade
 * call to action, both authored as rich text on the Contentstack website config.
 */
export const MemberPricingBanner = ({
  isLoggedIn = false,
  resolvedCustomerType,
  className,
}: MemberPricingBannerProps) => {
  const { membershipCallToAction, membershipUpgradeCallToAction } = usePage()
  const isStandardCustomer =
    isLoggedIn && resolvedCustomerType === ResolvedCustomerType.Standard

  if (isLoggedIn && !isStandardCustomer) {
    return null
  }

  const content = isStandardCustomer
    ? membershipUpgradeCallToAction?.json
    : membershipCallToAction?.json

  if (!content) {
    return null
  }

  return (
    <div
      className={classNames(
        styles.banner,
        { [styles.upgrade]: isStandardCustomer },
        className
      )}>
      <RichText content={content} />
    </div>
  )
}
